import React from 'react';
import '../../styles/Dashboard/Updates.css';

const RecommendationCard = ({ title, date, description }) => (
  <div className="card mb-3">
    <div className="card-body d-flex justify-content-between align-items-start">
      <div>
        <h5 className="card-title">{title}</h5>
        <p className="card-text text-muted">Created - {date}</p>
        <div className="d-flex align-items-center mt-2">
          <svg 
            className="icon" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 4v16m8-8H4" 
            />
          </svg>
          <p className="card-text ml-2">{description}</p>
        </div>
      </div>
      <button className="btn btn-link text-danger">
        View
      </button>
    </div>
  </div>
);

const RecommendationsUpdate = () => {
 
  const recommendations = [
    {
      id: 1,
      title: "Document name",
      date: "Oct 29, 2024",
      description: "Actionable steps to enhance performance a..."
    },
    {
      id: 2,
      title: "Document name",
      date: "Oct 29, 2024",
      description: "Actionable steps to enhance performance a..."
    }
  ];

  return (
    <div className="container">
      <div className="card p-3">
        <div className="card-header">
          <h4 className="mb-0">Recommended for update</h4>
        </div>
        
        <div className="card-body">
          {recommendations.map((rec) => (
            <RecommendationCard
              key={rec.id}
              title={rec.title}
              date={rec.date}
              description={rec.description}
            />
          ))}
        </div>
        
        <div className=" text-center">
          <button className="btn btn-danger w-100">
            View all recommendations
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecommendationsUpdate;